<script setup>
import { onMounted } from 'vue';
import { useUserStore } from './stores/user.store';
import { JwtService } from './services/api.service';

const userStore = useUserStore();

onMounted(async () => {
  if (JwtService.hasToken()) {
    try {
      console.log('App.vue: Loading user data...');
      await userStore.fetchCurrentUser();
      console.log('App.vue: User data loaded, isAdmin:', userStore.isAdmin);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  }
});
</script>

<template>
  <RouterView />
</template>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
